<template>
    <Head>
        <link
            rel="shortcut icon"
            :href="$page.props.brand.favicon"
        >

        {{ watsonSeoHead || yoastHead }}
    </Head>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';

defineProps({
    yoastHead: {
        type: String,
        required: false,
        default: '',
    },
    watsonSeoHead: {
        type: String,
        required: false,
        default: '',
    },
});
</script>
